import { TenantTheme } from 'styled-components';

const primary = '#FFD100';
const secondary = '#282850';
const grey = '#F4F5F9';

const theme: TenantTheme = {
  colors: {
    primary,
  },

  text: {
    primary: secondary,
    secondary: '#5E5E7E',
  },

  selection: {
    bg: primary,
  },

  button: {
    size: {
      default: {
        default: {
          height: '3rem',
          fontSize: '1.125rem',
          padding: '0.8125rem 0',
          lineHeight: '1.9375rem',
        },
        sm: {
          height: '3.75rem',
          padding: '1.3125rem 0',
        },
      },

      xl: {
        default: {
          height: '4rem',
          fontSize: '1.125rem',
          padding: '0.8125rem 0',
          lineHeight: '1.9375rem',
        },
        sm: {
          height: '4.5rem',
          padding: '1.3125rem 0',
        },
      },
    },

    primary: {
      default: {
        borderRadius: '0.5rem',
        color: secondary,
        bg: primary,
        fontWeight: 'bold',
      },
    },

    ShowMore: {
      default: {
        color: secondary,
      },
    },
  },

  checkbox: {
    default: {
      checkAllLabelColor: secondary,
      borderColor: secondary,
      labelColor: '#5E5E7E',
      fillColor: secondary,
    },
  },

  consents: {
    container: {
      bg: grey,
    },

    item: {
      bg: '#DCDFEB',
    },
  },

  aspsp: {
    bg: grey,
    borderColor: {
      default: grey,
      selected: secondary,
    },
  },
};

export default theme;
